<style lang="less">
.identyty{
	padding-bottom: 54px;
	.disable{
		color: #999;
	}
	.agreement{
		.tit{
			color: #dc2a2a;
			font-weight: 500;
		}
	}
	.bank{
		text-align: center;
		font-size: 12px;
		font-weight: 500;
		color: #dc2a2a;
		width: 100%;
		position: fixed;
		bottom: 85px;
		left: 0;
		display: -webkit-box; display:flex;
		-webkit-box-align: center; align-items: center;
		-webkit-box-pack: center; justify-content: center;
	}
}
@media only screen and (max-height: 360px) {
	.bank{
		display: none !important;
	}
}
</style>

<template>
	<!-- Main identyty -->
	<section class="identyty">
		<div class="form">
			<div class="item">
				<div class="label">姓名</div>
				<div class="cont">
					<input type="text" value="" placeholder="真实姓名" v-model="isIdentity.holder_name" disabled="disabled" class="disable" v-if="isIdentity.holder_name" />
					<input type="text" value="" placeholder="真实姓名" v-model="info.holder_name" maxlength="8" v-else />
				</div>
			</div>
			<div class="item">
				<div class="label">身份证号</div>
				<div class="cont">
					<input type="text" value="" placeholder="身份证号将加密处理" v-model="isIdentity.cert_no" disabled="disabled" class="disable" v-if="isIdentity.cert_no" />
					<input type="tel" value="" placeholder="身份证号将加密处理" v-model="info.cert_no" maxlength="18" v-else />
				</div>
			</div>
			<div class="explain">请填写本人身份信息，绑定后无法修改</div>
		</div>
		<div class="form_space"></div>
		<div class="form">
			<div class="item" v-show="!info.bacc_no_i">
				<div class="label">银行卡号</div>
				<div class="cont">
					<input type="tel" value="" placeholder="输入储蓄卡号" v-model="info.bacc_no" maxlength="21" />
				</div>
			</div>
			<div class="item" v-show="info.bacc_no_i" style="border-bottom: 0;">
				<itembank v-on:bankSelect="bankSelect"></itembank>
			</div>
			<!-- <div class="explain">绑定后自动充值 0.01 元以验证卡片</div> -->
		</div>
		<div class="form_space"></div>
		<div class="form">
			<div class="item">
				<div class="label">预留手机号</div>
				<div class="cont">
					<input type="text" maxlength="11" value="" placeholder="输入银行预留手机号" v-model="info.phone" class="disable" disabled="disabled" v-if="isIdentity.phone" />
					<input type="tel" maxlength="11" value="" placeholder="输入银行预留手机号" v-model="info.phone" v-else />
				</div>
			</div>
			<smscode v-on:send="getBankInfo" v-on:smscode="setSmsCode" :initSecond="initSecondTimes"></smscode>
			<div class="tips" v-show="tips">{{tips}}</div>
		</div>

		<div class="bank">
			<p @click="banklist">支持银行</p>
		</div>

		<agreement :agree="agree" v-on:toggleAgree="toggleAgree">
			<div slot="agree">
				<span>我已阅读并同意</span>
				<span class="tit" @click="toRichText(0)">《相关协议》</span>
				<!-- <span class="tit" @click="toRichText(1)">《用户协议》</span>
				<span>、</span>
				<span class="tit" @click="toRichText(2)">《服务协议》</span>
				<span>、</span>
				<span class="tit" @click="toRichText(3)">《账户协议》</span> -->
			</div>
		</agreement>

		<footbtn btn-txt="下一步" :is-on="isActive" @click.native="next"></footbtn>

	</section>
</template>

<script>
	/*
		global track
	*/
	import android from '@flyme/jr/js/android.js';
	import item from '@flyme/jr/flyme7/component/item/vue-item.vue';
	import footbtn from '@flyme/jr/flyme7/component/foot-btn-simple/foot-btn-simple.vue';
	import poplist from '@flyme/jr/flyme7/component/pop-list/pop-list.vue';
	import itembank from '../components/bankSelect.vue';

	import axios from '../axios.js';
	import apis from '../apis.js';
	import config from '../config.js';
	import smscode from '../components/smscode.vue';
	import agreement from '@flyme/jr/flyme7/component/agreement/agreement.vue';

	export default {
		data: function() {
			return {
				agree: true,
				tips: '',
				bank: {
					index: -1,
					isShow: false,
					data: []
				},
				info: {
					user_id: '',
					partner_id: config.partner_id,
					partner_cp_type: config.partner_cp_type,
					bacc_no_i: '',
					bacc_no_l4: '',
					bacc_no: '',
					acc_type: '',
					bank_name: '',
					holder_name: '',
					bank_code: '',
					cert_no: '',
					phone: '',
					token: '',
					verify_code: ''
				},
				isIdentity: {
					holder_name: '',
					cert_no: '',
					phone: ''
				},
				initSecondTimes: '0'
			};
		},
		computed: {
			isActive: function() {
				var check = false;
				if (this.info.user_id && this.info.token && this.info.verify_code && this.agree) {
					check = true;
				}
				return check;
			}
		},
		components: {
			item,
			itembank,
			smscode,
			footbtn,
			agreement,
			poplist
		},
		created: function () {
			android('setTitle', {
				title:"完善信息"
			});
			android('hideLoadingDialog');
			android('startLoading', {mes: '正在加载'});
			this.getUserInfo();
			this.getPerFill();
		},
		mounted: function() {},
		methods: {
			getUserInfo: function () {
				let _this = this;
				android('getUserInfo', {}, function (d) {
					_this.info.user_id = d.userId;
				});
			},
			getPerFill: function () {
				let _this = this;
				axios.post(apis.identity_query, {}).then(function(d) {
					console.log('identity_query', d);
					if (d.value) {
						// _this.info.holder_name = d.value.user_name;
						// _this.info.cert_no = d.value.cert_no;
						_this.isIdentity.holder_name = d.value.user_name;
						_this.isIdentity.cert_no = d.value.cert_no;
					}else{
						_this.isIdentity.holder_name = '';
						_this.isIdentity.cert_no = '';
					}
					android('stopLoading');
				}).catch(function () {
					android('stopLoading');
				});
			},
			getBankInfo: function () {
				let _this = this;

				this.tips = '';

				if (this.info.bacc_no_i) {
					this.sendsms();
					return;
				}
				axios.post(apis.bank_query, {
					bacc_no: this.info.bacc_no,
					type: 1,
					partner_id: config.partner_id,
					partner_cp_type: config.partner_cp_type,
					client_payment_types: ''
				}).then(function(d) {
					console.log('bank_query', d);
					if (d.code != 200) {
						_this.initSecondTimes += 1;
						_this.tips = d.message;
					}else{
						if (!d.value.support) {
							_this.initSecondTimes += 1;
							_this.tips = '暂不支持该卡，请换卡再试';
							return;
						}
						_this.info.acc_type = d.value.cardType;
						_this.info.bank_code = d.value.bankCode;
						_this.info.bank_name = d.value.bankName;
						_this.sendsms();
					}
				});
			},
			bankSelect: function (d) {
				this.info.bacc_no_i = d.id;
				this.info.bacc_no_l4 = d.raw.bankNoLast4;
				this.info.acc_type = d.raw.bankAccType;
				this.info.bank_name = d.raw.bankName;
				this.info.phone = d.raw.phone;
				this.isIdentity.phone = d.raw.phone;
			},
			sendsms: function () {
				let _this = this;
				android('showLoadingDialog', {
					mes: '正在加载'
				});
				if (this.info.bacc_no_i === '' && this.info.bacc_no_l4 === '') {
					delete this.info.bacc_no_i;
					delete this.info.bacc_no_l4;
				}
				if (this.info.bacc_no_i) {
					delete this.info.acc_type;
				}
				axios.post(apis.bank_sms_code, this.info).then(function(d) {
					console.log('bank_sms_code', d, _this.info);
					android('hideLoadingDialog');
					if (d.code != 200) {
						_this.initSecondTimes += 1;
						_this.tips = d.message;
					}else{
						_this.info.token = d.value.token;
					}
				});
			},
			setSmsCode: function (code) {
				this.info.verify_code = code;
			},
			next: function () {
				let _this = this;

				if (!this.isActive) {
					return;
				}

				android('showLoadingDialog', {
					mes: '正在加载'
				});
				axios.post(apis.bank_bind, this.info).then(function(d) {
					console.log('bank_bind', d);
					android('hideLoadingDialog');
					if (d.code != 200) {
						_this.tips = d.message;
						track('event_ecash_bank_bind_faild');
					}else{
						if (d.value.result) {
							track('event_ecash_bank_bind_success');
							_this.$router.replace({path: '/verify'});
						}
					}
				});
			},
			toggleAgree: function () {
				this.agree = !this.agree;
			},
			toRichText: function (key) {
				var ids = {
					"0": {
						"id": "1530172363953",
						"title": "相关协议"
					},
					"1": {
						"id": '1529406827400',
						"title": '魅族现金账户用户协议'
					},
					"2": {
						"id": '1529406880278',
						"title": '国寿安保慧存钱服务协议'
					},
					"3": {
						"id": '1529406861961',
						"title": '广发直销银行电子账户服务协议'
					}
				};

				android('startPage', {
					url: 'https://wallet.mzres.com/static/richtext/index.html?show_padding=1&id=' + ids[key].id,
					start_type:1,
					data:'',
					display:{
						title: ids[key].title
					}
				});
			},
			banklist: function () {
				android('startPage', {
					url: config.staticURL + '/#/support/bank',
					start_type: 1,
					data: '',
					display: {
						title: '支持银行'
					}
				});
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/pages/Identity.vue